let bundleRemovalInProgress = false;

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();

      const cartItems =
        this.closest('cart-products') ||
        this.closest('cart-drawer-items');

      const hasSubscriptionBundle =
        this.dataset.removeproducts &&
        this.dataset.removeproducts !== '';

if (bundleRemovalInProgress) {
  return;
}

if (this.dataset.key) {
  bundleRemovalInProgress = true;
  console.log('Removing selected product and reducing its subscription parts');

  const parentLineKey = this.dataset.key;

const innerProductIds = hasSubscriptionBundle
  ? this.dataset.removeproducts
      .replace('[', '')
      .replace(']', '')
      .split(',')
      .map(id => Number(id.trim()))
      .filter(Boolean)
  : [];

  fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => {
      if (!response.ok) {
        throw new Error('Could not read the current cart');
      }

      return response.json();
    })
    .then(cart => {
      const parentItem = cart.items.find(item => {
        return item.key === parentLineKey;
      });

      if (!parentItem) {
        throw new Error('Could not find the purifier being removed');
      }

      const purifierQuantity = parentItem.quantity || 1;

      const updates = {
        [parentLineKey]: 0
      };

innerProductIds.forEach(variantId => {
  const childItem = cart.items.find(item => {
    return Number(item.variant_id) === variantId;
  });

  if (!childItem) return;

  const remainingNeededQuantity = cart.items
    .filter(item => {
      return (
        item.key !== parentLineKey &&
        item.properties &&
        item.properties._inner_products &&
        item.properties._inner_products.includes(String(variantId))
      );
    })
    .reduce((total, item) => {
      return total + item.quantity;
    }, 0);

  updates[childItem.key] = remainingNeededQuantity;
});

// Remove protection plans attached to this purifier
const parentProductId = String(
  parentItem.properties?._product_id ||
  parentItem.product_id ||
  ''
);

cart.items.forEach(item => {
  const protectionParentKey = String(
    item.properties?._protection_parent_key || ''
  );

  const protectionParentProductId = String(
    item.properties?._protection_parent_product_id || ''
  );

  const matchesParentKey =
    protectionParentKey === String(parentLineKey);

  const matchesParentProduct =
    parentProductId !== '' &&
    protectionParentProductId === parentProductId;

  if (matchesParentKey || matchesParentProduct) {
    updates[item.key] = 0;
  }
});

      return fetch(
        window.Shopify.routes.root + 'cart/update.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ updates })
        }
      );
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Could not remove purifier bundle');
      }

      return response.json();
    })
    .then(() => {
      cartItemCount();
      this.getSectionsToRender();
    })
   .catch(error => {
  console.error('Bundle removal error:', error);
})
.finally(() => {
  bundleRemovalInProgress = false;
});

} else {
  cartItems.updateQuantity(this.dataset.index, 0);
}

    });
  }

  getSectionsToRender() {
    fetch(window.Shopify.routes.root + 'cart')
    .then((response) => response.text())
    .then((data) => {
      let html_div = document.createElement('div');
      html_div.innerHTML = data;
      let html_dom = html_div.querySelector('.drawer__inner').innerHTML;
      document.querySelector('.drawer__inner').innerHTML = html_dom;

      
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    .finally(() => {
       //
       getDataCart();
       openProtectionPopupInDrawerCart()
        promocodeSlideToggle()
        checkDoscuntLabelInAppTotalsDrawers();
    });
   
  }


}

customElements.define('remove-item', CartRemoveButton);


class CartItems extends HTMLElement {
  constructor() {
    super();

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
      
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
    
 
  }

 onChange(event) {
  if (bundleRemovalInProgress) {
    return;
  }

  const cartItem = event.target.closest('.cart-item');

  const removeProductsValue =
    event.target.dataset.removeproducts ||
    cartItem?.dataset.removeproducts ||
    '';

  const parentLineKey =
    event.target.dataset.key ||
    cartItem?.dataset.key;

if (
  Number(event.target.value) <= 0 &&
  parentLineKey
) {
    bundleRemovalInProgress = true;
    console.log('Removing purifier and reducing shared subscription parts');

const innerProductIds = removeProductsValue
  ? removeProductsValue
      .replace('[', '')
      .replace(']', '')
      .split(',')
      .map(id => Number(id.trim()))
      .filter(Boolean)
  : [];

    fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => {
        if (!response.ok) {
          throw new Error('Could not read the current cart');
        }

        return response.json();
      })
      .then(cart => {
        const parentItem = cart.items.find(item => {
          return item.key === parentLineKey;
        });

        if (!parentItem) {
          throw new Error('Could not find the purifier being removed');
        }

        const purifierQuantity = parentItem.quantity || 1;

        const updates = {
          [parentLineKey]: 0
        };

innerProductIds.forEach(variantId => {
  const childItem = cart.items.find(item => {
    return Number(item.variant_id) === variantId;
  });

  if (!childItem) return;

  const remainingNeededQuantity = cart.items
    .filter(item => {
      return (
        item.key !== parentLineKey &&
        item.properties &&
        item.properties._inner_products &&
        item.properties._inner_products.includes(String(variantId))
      );
    })
    .reduce((total, item) => {
      return total + item.quantity;
    }, 0);

  updates[childItem.key] = remainingNeededQuantity;
});

// Add this here
const parentProductId = String(
  parentItem.properties?._product_id ||
  parentItem.product_id ||
  ''
);

cart.items.forEach(item => {
  const protectionParentKey = String(
    item.properties?._protection_parent_key || ''
  );

  const protectionParentProductId = String(
    item.properties?._protection_parent_product_id || ''
  );

  const matchesParentKey =
    protectionParentKey === String(parentLineKey);

  const matchesParentProduct =
    parentProductId !== '' &&
    protectionParentProductId === parentProductId;

  if (matchesParentKey || matchesParentProduct) {
    updates[item.key] = 0;
  }
});

        return fetch(
          window.Shopify.routes.root + 'cart/update.js',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ updates })
          }
        );
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Could not remove purifier bundle');
        }

        return response.json();
      })
      .then(() => {
  cartItemCount();

  return fetch(window.Shopify.routes.root + 'cart?refresh=' + Date.now())
    .then(response => response.text())
    .then(data => {
      const html_div = document.createElement('div');
      html_div.innerHTML = data;

            const newDrawerInner =
              html_div.querySelector('.drawer__inner');

            const currentDrawerInner =
              document.querySelector('.drawer__inner');

            if (newDrawerInner && currentDrawerInner) {
              currentDrawerInner.innerHTML =
                newDrawerInner.innerHTML;
            }
          })
          .finally(() => {
            getDataCart();
            openProtectionPopupInDrawerCart();
            promocodeSlideToggle();
            checkDoscuntLabelInAppTotalsDrawers();
          });
      })
      .catch(error => {
  console.error('Bundle removal error:', error);
})
.finally(() => {
  bundleRemovalInProgress = false;
})

  } else {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name')
    );
  }
}

  getSectionsToRender() {
  
    return [
      {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items').dataset.id,
          selector: '.js-contents',
      },
      {
          id: 'main-cart-footer',
          section: document.getElementById('main-cart-footer').dataset.id,
          selector: '.cart-total-text',
      }
    ];
  }

updateQuantity(line, quantity, name) {
  this.enableLoading(line);

  const requestedQuantity = Number(quantity);

  fetch(window.Shopify.routes.root + 'cart.js')
    .then((response) => {
      if (!response.ok) {
        throw new Error('Could not read the current cart');
      }

      return response.json();
    })
    .then((cart) => {
      const parentItem = cart.items[Number(line) - 1];

      if (!parentItem) {
        throw new Error('Could not find the cart item being updated');
      }

      const parentLineKey = parentItem.key;

      const parentProductId = String(
        parentItem.properties?._product_id ||
        parentItem.product_id ||
        ''
      );

      const isParentProduct =
        parentItem.properties?._subscription_child !== 'true' &&
        parentItem.properties?._protection_child !== 'true';

      const updates = {
        [parentLineKey]: requestedQuantity
      };

      if (isParentProduct && parentProductId) {
        const matchingParentItems = cart.items.filter((item) => {
          const itemProductId = String(
            item.properties?._product_id ||
            item.product_id ||
            ''
          );

          return (
            item.properties?._subscription_child !== 'true' &&
            item.properties?._protection_child !== 'true' &&
            itemProductId === parentProductId
          );
        });

        const attachedProtectionItems = cart.items.filter((item) => {
          if (item.properties?._protection_child !== 'true') {
            return false;
          }

          const protectionParentKey = String(
            item.properties?._protection_parent_key || ''
          );

          const protectionParentProductId = String(
            item.properties?._protection_parent_product_id || ''
          );

          const matchesExactParent =
            protectionParentKey === String(parentLineKey);

          const matchesJoinedParent =
            matchingParentItems.length === 1 &&
            protectionParentProductId === parentProductId;

          return matchesExactParent || matchesJoinedParent;
        });

        /*
         * Keep one protection line at the same quantity as
         * the purifier. Remove any duplicate protection lines.
         */
        attachedProtectionItems.forEach(
          (protectionItem, index) => {
            updates[protectionItem.key] =
              index === 0 ? requestedQuantity : 0;
          }
        );
      }

      const body = JSON.stringify({
        updates,
        sections: this
          .getSectionsToRender()
          .map((section) => section.section),
        sections_url: window.location.pathname
      });

      return fetch(
        window.Shopify.routes.root + 'cart/update.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body
        }
      );
    })
    .then((response) => {
      if (!response.ok) {
        throw new Error(
          'Could not synchronize the purifier and protection plan'
        );
      }

      return response.json();
    })
    .then((parsedState) => {
      cartItemCount();

      this.classList.toggle(
        'is-empty',
        parsedState.item_count === 0
      );

      const cartDrawerWrapper =
        document.querySelector('cart-drawer');

      const cartFooter =
        document.getElementById('main-cart-footer');

      if (cartFooter) {
        cartFooter.classList.toggle(
          'is-empty',
          parsedState.item_count === 0
        );
      }

      if (cartDrawerWrapper) {
        cartDrawerWrapper.classList.toggle(
          'is-empty',
          parsedState.item_count === 0
        );
      }

      this.getSectionsToRender().forEach((section) => {
        if (
          !parsedState.sections ||
          !parsedState.sections[section.section]
        ) {
          return;
        }

        const sectionContainer =
          document.getElementById(section.id);

        if (!sectionContainer) return;

        const elementToReplace =
          sectionContainer.querySelector(section.selector) ||
          sectionContainer;

        elementToReplace.innerHTML =
          this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
      });

      this.updateLiveRegions(
        line,
        parsedState.item_count
      );

      const lineItem =
        document.getElementById(`CartItem-${line}`) ||
        document.getElementById(
          `CartDrawer-Item-${line}`
        );

      if (
        lineItem &&
        name &&
        lineItem.querySelector(`[name="${name}"]`)
      ) {
        const focusTarget =
          lineItem.querySelector(`[name="${name}"]`);

        if (cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, focusTarget);
        } else {
          focusTarget.focus();
        }
      } else if (
        parsedState.item_count === 0 &&
        cartDrawerWrapper
      ) {
        const emptyDrawer =
          cartDrawerWrapper.querySelector(
            '.drawer__inner-empty'
          );

        const emptyDrawerLink =
          emptyDrawer?.querySelector('a');

        if (emptyDrawer && emptyDrawerLink) {
          trapFocus(emptyDrawer, emptyDrawerLink);
        }
      }

      this.disableLoading();

if (typeof getInnerProductsObjectsArray === 'function') {
  getInnerProductsObjectsArray(parsedState);
      }

      if (
        typeof openProtectionPopupInDrawerCart ===
        'function'
      ) {
        openProtectionPopupInDrawerCart();
      }

      if (
        typeof promocodeSlideToggle === 'function'
      ) {
        promocodeSlideToggle();
      }

      if (
        typeof checkDoscuntLabelInAppTotalsDrawers ===
        'function'
      ) {
        checkDoscuntLabelInAppTotalsDrawers();
      }
    })
    .catch((error) => {
      console.error(
        'Quantity synchronization error:',
        error
      );

      this
        .querySelectorAll('.loading-overlay')
        .forEach((overlay) => {
          overlay.classList.add('hidden');
        });

      this.disableLoading();
    });
}

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      lineItemError
        .querySelector('.cart-item-error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

   
setTimeout(() => {
  cartStatus.setAttribute('aria-hidden', true);
}, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items');
 
    const cartItemElements = this.querySelectorAll(`.cart-item[data-line="${line}"] .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`.cart-item[data-line="${line}"] .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
   
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items');
   
  }
}

customElements.define('cart-products', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300))
    }
  });
};

/*********************************************************** */
/********************** advanced js***************************/
/*********************************************************** */
//cart item count
function cartItemCount() {
fetch('/cart.js')
.then(response => {
  return response.json();
})
.then(data => {
 
  let cartCount = document.querySelectorAll('.cart-counter');
  cartCount.forEach(item => {
    item.innerHTML = data.item_count;
  })
})
.catch((error) => {
  console.error('Error:', error);
});

}




var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
if(typeof currencyIso_code !== 'undefined'){
if(currencyIso_code == ''){
    currencyIso_code = '$'
}
}else{
  var currencyIso_code = '$'
}

Shopify.money_format = '{{amount}}';
Shopify.formatMoney = function(cents, format) {
if (typeof cents == 'string') { cents = cents.replace('.',''); }
var value = '';
var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
var formatString = (format || this.money_format);

function defaultOption(opt, def) {
  return (typeof opt == 'undefined' ? def : opt);
}

function formatWithDelimiters(number, precision, thousands, decimal) {
  precision = defaultOption(precision, 2);
  thousands = defaultOption(thousands, ',');
  decimal   = defaultOption(decimal, '.');

  if (isNaN(number) || number == null) { return 0; }

  number = (number/100.0).toFixed(precision);

  var parts   = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents   = parts[1] ? (decimal + parts[1]) : '';

  return dollars + cents;
}

switch(formatString.match(placeholderRegex)[1]) {
  case 'amount':
    value = formatWithDelimiters(cents, 2);
    break;
  case 'amount_no_decimals':
    value = formatWithDelimiters(cents, 0);
    break;
  case 'amount_with_comma_separator':
    value = formatWithDelimiters(cents, 2, '.', ',');
    break;
  case 'amount_no_decimals_with_comma_separator':
    value = formatWithDelimiters(cents, 0, '.', ',');
    break;
}

return formatString.replace(placeholderRegex, value);
};


//Free delivery price count
function drawerFreeDelveryLine(totalPrice){

if(document.querySelectorAll('.cart-freeshipping-line').length > 0){
  
  document.querySelectorAll('.cart-freeshipping-line').forEach((item)=>{
    if(item.dataset.shipping){
      let currentTotal = Shopify.formatMoney(totalPrice, Shopify.money_format).replace(/\,/g,'');
      let freeMoneyDelivery = Number(item.dataset.shipping); 

      let leaveMoney = 0;
      let percentleave = 0; 
    
      if(currentTotal < freeMoneyDelivery){
          leaveMoney = freeMoneyDelivery - Number(currentTotal);
          leaveMoney = parseFloat(leaveMoney.toFixed(4))
          percentleave = Number(currentTotal) * 100 / freeMoneyDelivery;
          item.querySelector('.cart-freeshipping-indicator-line').style.left = percentleave-100+'%'
          item.classList.remove('free-get');


      }else{
        item.querySelector('.cart-freeshipping-indicator-line').style.left = '0';
        item.classList.add('free-get');
        
      }
      item.querySelector('.cart-freeshipping-price').innerHTML = currencyIso_code+''+leaveMoney;

    }
  })
}
}


